import { useState } from 'react';
import { UNIT_TYPES, formatQty, variantLabel } from '@pos/core';
import type { VariantStock } from '@pos/local-db';
import { Alert, Card, cx } from '../../ui/index.tsx';
import { ProductPicker, type PickedVariant } from '../products/ProductPicker.tsx';
import type { Catalog } from '../products/data.ts';

/**
 * «Vender» en modo consulta (suscripción en solo lectura), para el dueño: se buscan productos
 * y se ven precio y stock, sin carrito ni cobro.
 */
export function PriceCheck({ catalog, stock, money }: { catalog: Catalog; stock: Map<string, VariantStock>; money: (cents: number) => string }) {
  const [picked, setPicked] = useState<PickedVariant | null>(null);
  const s = picked ? stock.get(picked.variant.id) : undefined;
  const attrs = picked ? variantLabel(picked.variant.attributes) : '';

  return (
    <div className="mx-auto max-w-2xl space-y-3">
      <Alert tone="warning" title="Modo consulta">
        La suscripción no permite vender. Podés buscar productos para ver su precio y stock.
      </Alert>
      <ProductPicker
        catalog={catalog}
        onPick={(p) => setPicked(p)}
        autoFocus
        placeholder="Buscá o escaneá un producto para ver su precio…"
        renderMeta={(o) => <span className="block font-medium text-slate-800">{money(o.variant.price)}</span>}
      />
      {picked && (
        <Card className="space-y-1">
          <p className="text-lg font-semibold">
            {picked.item.product.name}
            {attrs && <span className="font-normal text-slate-500"> · {attrs}</span>}
          </p>
          <p className="text-3xl font-semibold tabular-nums">{money(picked.variant.price)}</p>
          {picked.item.product.unit_type !== 'unit' && <p className="text-sm text-slate-500">por {UNIT_TYPES[picked.item.product.unit_type].symbol}</p>}
          {s?.tracked && (
            <p className={cx('text-sm', s.qty <= 0 ? 'text-red-700' : 'text-slate-600')}>Stock: {formatQty(s.qty, picked.item.product.unit_type)}</p>
          )}
          {picked.variant.barcode && <p className="text-xs text-slate-500">Código {picked.variant.barcode}</p>}
        </Card>
      )}
    </div>
  );
}
